import { InboxOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Checkbox, Button, Upload, message } from 'antd';
import JoditEditor from 'jodit-react';
import React, { useRef, useState } from 'react';
import { ViewDocument } from '../../../components';
import './index.css';

function TestQuestion({
  dictionary,
  language,
  form,
  Answers,
  multiQuestionAnswerFiles,
  setMultiQuestionAnswerFiles,
}) {
  const editor = useRef(null);
  const [filesOptions, setFilesOptions] = useState([
    { fileIndex: 0, withFile: false, fileLists: [] },
  ]);

  if (Answers) {
    form.setFieldsValue({ tests: Answers });
  }

  const config = {
    readonly: false,
    limitChars: 2000,
    placeholder: '',
  };

  function prepareFiles(file) {
    file.onSuccess('ok');
  }


  return (
    <Form.List name="tests">
      {(fields, { add, remove }) => (
        <>
          {fields.map((field, index) => {
            return (
              <div className="box" key={field.key}>
                <Form.Item
                  label={`Вариант ответа ${index + 1}`}
                  name={[field.name, 'answerHtml']}
                  fieldKey={[field.fieldKey, 'answerHtml']}
                  rules={[
                    {
                      required: true,
                      message: `Заполните ответ ${index + 1}`,
                    },
                  ]}>
                  <JoditEditor ref={editor} config={config} tabIndex={1} />
                </Form.Item>
                <Form.Item
                  label={'Правильный вариант'}
                  name={[field.name, 'isRight']}
                  fieldKey={[field.fieldKey, 'isRight']}>
                  <Checkbox
                    checked={form.getFieldValue('tests')[field.fieldKey]?.isRight}
                    onChange={(e) => {
                      form.setFieldsValue({
                        ...form.getFieldsValue(),
                        tests: form.getFieldsValue().tests.map((el, index) => {
                          return index === field.fieldKey ? { ...el, isRight: !el.isRight } : el;
                        }),
                      });
                    }}
                  />
                </Form.Item>
                { Answers && form.getFieldValue('tests')[field.fieldKey]?.files.length > 0 &&
                  <Form.Item label={dictionary?.File[language]}>
                    <ViewDocument files={form.getFieldValue('tests')[field.fieldKey]?.files} />
                  </Form.Item>
                }
                { !Answers && <Form.Item
                  name={[field.name, 'answerFile']}
                  fieldKey={[field.fieldKey, 'answerFile']}
                  colon={false}
                  label={
                    <div>
                      {dictionary?.AttachFile[language]} :
                      <Checkbox
                        onChange={(e) =>
                          setFilesOptions([
                            ...filesOptions.map((f) => {
                              return f.fileIndex === index ? { ...f, withFile: !f.withFile } : f;
                            }),
                          ])
                        }
                        checked={filesOptions[index]?.withFile}
                        size="large"
                      />
                    </div>
                  }>
                  <Upload.Dragger
                    customRequest={(e) => prepareFiles(e)}
                    disabled={!filesOptions[index]?.withFile}
                    multiple={true}
                    style={{ height: '15px', width: '100%' }}
                    onChange={({ file, fileList }) => {
                      if (file.status === 'removed') {
                        setFilesOptions([
                          ...filesOptions.map((f) => {
                            return f.fileIndex === index
                              ? {
                                ...f,
                                fileLists: f.fileLists.filter((s) => s.index !== file.index),
                              }
                              : f;
                          }),
                        ]);
                        setMultiQuestionAnswerFiles(
                          multiQuestionAnswerFiles.map((el) => {
                            return el.index === index
                              ? {
                                ...el,
                                fileLists: el.fileLists.filter((s) => s.uid !== file.file.uid),
                              }
                              : el;
                          }),
                        );
                      } else if (file.status === 'done') {
                        if (file.size <= 5000000) {
                          if (filesOptions[index].fileLists.length < 2) {
                            setFilesOptions([
                              ...filesOptions.map((f) => {
                                return f.fileIndex === index
                                  ? {
                                    ...f,
                                    fileLists: [
                                      ...f.fileLists,
                                      {
                                        file: file,
                                        name: file.name,
                                        index: filesOptions[index].fileLists.length,
                                        uid: Date.now().toString(),
                                      },
                                    ],
                                  }
                                  : f;
                              }),
                            ]);
                            setMultiQuestionAnswerFiles([
                              ...multiQuestionAnswerFiles.map((el) => {
                                return el.index === index
                                  ? {
                                    ...el,
                                    fileLists: [...el.fileLists, file],
                                  }
                                  : el;
                              }),
                            ]);
                          } else {
                            message.error('Максимум 2 файла');
                          }
                        } else {
                          message.error('Не больше 5 МВ');
                        }
                      }
                    }}
                    fileList={filesOptions && filesOptions[index] ? filesOptions[index].fileLists : []}>
                    <p className="ant-upload-drag-icon">
                      <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">{dictionary?.MaxFile[language]}</p>
                  </Upload.Dragger>
                </Form.Item>
                }
                { !Answers && <Button
                  type="primary"
                  shape="round"
                  danger={true}
                  style={{ marginLeft: 80, marginBottom: 25 }}
                  icon={<MinusCircleOutlined />}
                  onClick={() => {
                    remove(field.name);
                  }}>
                  {dictionary?.Delete[language]}
                </Button>
                }
              </div>
            );
          })}
          { !Answers && <Form.Item labelAlign="right">
            <Button
              type="primary"
              shape="round"
              style={{ marginTop: 20, marginLeft: 80 }}
              icon={<PlusOutlined />}
              onClick={() => {
                add();
                setFilesOptions([
                  ...filesOptions,
                  { fileIndex: filesOptions.length, withFile: false, fileLists: [] },
                ]);
                setMultiQuestionAnswerFiles([
                  ...multiQuestionAnswerFiles,
                  { index: multiQuestionAnswerFiles.length, fileLists: [] },
                ]);
              }}>
              {dictionary?.AddMore[language]}
            </Button>
          </Form.Item>
          }
        </>
      )}
    </Form.List>
  );
}

export default TestQuestion;
